import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { ProductMockup } from './components/ProductMockup';
import { Includes } from './components/Includes';
import { TargetAudience } from './components/TargetAudience';
import { Benefits } from './components/Benefits';
import { SocialProof } from './components/SocialProof';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen font-sans text-brand-navy bg-brand-cream selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Agitation data-id="element-3" />
      <Solution data-id="element-4" />
      <ProductMockup data-id="element-5" />
      <Includes data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <Benefits data-id="element-8" />
      <SocialProof data-id="element-9" />
      <Offer data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}